import {
    Truck, Package, PackageCheck, Plane, Ship, MapPin, Bike, Container,
    Headset, MessageCircle, MessagesSquare, Phone, Mail, Users, UserCheck, Handshake, Smile, Clock, LifeBuoy, BellRing,
    Calculator, FileText, ClipboardList, Receipt, CreditCard, DollarSign, Banknote, Coins, Percent, BadgePercent, PiggyBank, Wallet,
    Star, Award, Medal, Trophy, BadgeCheck, ShieldCheck, ThumbsUp, Gem, Crown, Sparkles, Heart, CircleCheck,
    Palette, Brush, PenTool, Stamp, Printer, Shirt, Scissors, Layers, WandSparkles, Ruler, Factory, Lightbulb,
    ShoppingBag, ShoppingCart, Store, Gift, Box, Boxes, Tag, Tags, Barcode, QrCode, Image, Camera,
    Building2, Briefcase, Globe, Rocket, Target, Zap, Leaf, Recycle, Calendar, CalendarCheck, Timer, RefreshCw, Repeat, Lock, TrendingUp, Send
} from "lucide-react";

/**
 * Catálogo curado de ícones (https://lucide.dev) oferecido ao cliente nas telas
 * de conteúdo do site. É curado de propósito: a biblioteca inteira tem mais de
 * mil ícones e a escolha viraria um problema para quem só quer trocar o
 * desenho de uma vantagem da home.
 *
 * `search` são os termos que o cliente provavelmente digita (inclui as palavras
 * sem acento, porque a busca compara texto normalizado).
 */
const CATALOG = [
    {
        group: 'Entrega e frete',
        icons: [
            { name: 'Truck', component: Truck, label: 'Caminhão', search: 'frete entrega envio transporte caminhao' },
            { name: 'Package', component: Package, label: 'Caixa', search: 'pacote encomenda produto embalagem' },
            { name: 'PackageCheck', component: PackageCheck, label: 'Pedido conferido', search: 'pacote entregue conferido pedido ok' },
            { name: 'Plane', component: Plane, label: 'Avião', search: 'aereo rapido urgente entrega' },
            { name: 'Ship', component: Ship, label: 'Navio', search: 'maritimo importacao navio' },
            { name: 'MapPin', component: MapPin, label: 'Localização', search: 'endereco mapa local regiao cobertura' },
            { name: 'Bike', component: Bike, label: 'Bicicleta', search: 'motoboy entrega rapida local' },
            { name: 'Container', component: Container, label: 'Contêiner', search: 'estoque armazem logistica volume' },
        ]
    },
    {
        group: 'Atendimento',
        icons: [
            { name: 'Headset', component: Headset, label: 'Headset', search: 'atendimento suporte sac telefone' },
            { name: 'MessageCircle', component: MessageCircle, label: 'Conversa', search: 'chat whatsapp mensagem falar' },
            { name: 'MessagesSquare', component: MessagesSquare, label: 'Conversas', search: 'chat mensagens atendimento' },
            { name: 'Phone', component: Phone, label: 'Telefone', search: 'ligar contato fone' },
            { name: 'Mail', component: Mail, label: 'E-mail', search: 'email mensagem contato' },
            { name: 'Users', component: Users, label: 'Equipe', search: 'time pessoas equipe especialistas' },
            { name: 'UserCheck', component: UserCheck, label: 'Consultor', search: 'vendedor consultor dedicado pessoa' },
            { name: 'Handshake', component: Handshake, label: 'Aperto de mão', search: 'parceria negocio acordo confianca' },
            { name: 'Smile', component: Smile, label: 'Sorriso', search: 'satisfacao cliente felicidade' },
            { name: 'Clock', component: Clock, label: 'Relógio', search: 'prazo horario rapido tempo' },
            { name: 'LifeBuoy', component: LifeBuoy, label: 'Suporte', search: 'ajuda socorro suporte' },
            { name: 'BellRing', component: BellRing, label: 'Aviso', search: 'notificacao aviso novidade' },
        ]
    },
    {
        group: 'Orçamento e pagamento',
        icons: [
            { name: 'Calculator', component: Calculator, label: 'Calculadora', search: 'orcamento calculo preco cotacao' },
            { name: 'FileText', component: FileText, label: 'Documento', search: 'orcamento proposta pdf documento' },
            { name: 'ClipboardList', component: ClipboardList, label: 'Lista', search: 'orcamento cotacao pedido lista' },
            { name: 'Receipt', component: Receipt, label: 'Nota', search: 'nota fiscal recibo faturamento' },
            { name: 'CreditCard', component: CreditCard, label: 'Cartão', search: 'pagamento parcelado cartao faturar' },
            { name: 'DollarSign', component: DollarSign, label: 'Dinheiro', search: 'preco valor pagamento dinheiro' },
            { name: 'Banknote', component: Banknote, label: 'Cédula', search: 'pagamento dinheiro boleto valor' },
            { name: 'Coins', component: Coins, label: 'Moedas', search: 'preco economia custo dinheiro' },
            { name: 'Percent', component: Percent, label: 'Porcentagem', search: 'desconto promocao oferta' },
            { name: 'BadgePercent', component: BadgePercent, label: 'Selo de desconto', search: 'melhor preco desconto oferta promocao' },
            { name: 'PiggyBank', component: PiggyBank, label: 'Economia', search: 'economia poupar barato custo' },
            { name: 'Wallet', component: Wallet, label: 'Carteira', search: 'pagamento condicoes carteira' },
        ]
    },
    {
        group: 'Qualidade e confiança',
        icons: [
            { name: 'Star', component: Star, label: 'Estrela', search: 'qualidade avaliacao destaque nota' },
            { name: 'Award', component: Award, label: 'Selo', search: 'premio qualidade certificado' },
            { name: 'Medal', component: Medal, label: 'Medalha', search: 'premio primeiro qualidade' },
            { name: 'Trophy', component: Trophy, label: 'Troféu', search: 'premio campeao melhor' },
            { name: 'BadgeCheck', component: BadgeCheck, label: 'Verificado', search: 'aprovado garantia verificado confianca' },
            { name: 'ShieldCheck', component: ShieldCheck, label: 'Escudo', search: 'seguranca garantia confianca protecao' },
            { name: 'ThumbsUp', component: ThumbsUp, label: 'Curtir', search: 'aprovado satisfacao recomendado' },
            { name: 'Gem', component: Gem, label: 'Diamante', search: 'premium exclusivo qualidade valor' },
            { name: 'Crown', component: Crown, label: 'Coroa', search: 'premium exclusivo melhor' },
            { name: 'Sparkles', component: Sparkles, label: 'Brilho', search: 'novidade especial exclusivo destaque' },
            { name: 'Heart', component: Heart, label: 'Coração', search: 'favorito cuidado carinho' },
            { name: 'CircleCheck', component: CircleCheck, label: 'Confirmado', search: 'ok certo aprovado confirmado' },
        ]
    },
    {
        group: 'Personalização e produção',
        icons: [
            { name: 'Palette', component: Palette, label: 'Paleta', search: 'cores personalizacao arte design' },
            { name: 'Brush', component: Brush, label: 'Pincel', search: 'pintura arte personalizacao' },
            { name: 'PenTool', component: PenTool, label: 'Vetor', search: 'arte layout design criacao' },
            { name: 'Stamp', component: Stamp, label: 'Carimbo', search: 'gravacao marca personalizacao' },
            { name: 'Printer', component: Printer, label: 'Impressora', search: 'impressao grafica gravacao' },
            { name: 'Shirt', component: Shirt, label: 'Camiseta', search: 'vestuario uniforme camiseta brinde' },
            { name: 'Scissors', component: Scissors, label: 'Tesoura', search: 'corte acabamento producao' },
            { name: 'Layers', component: Layers, label: 'Camadas', search: 'variedade opcoes camadas' },
            { name: 'WandSparkles', component: WandSparkles, label: 'Varinha', search: 'personalizacao magica criacao especial' },
            { name: 'Ruler', component: Ruler, label: 'Régua', search: 'medida tamanho sob medida' },
            { name: 'Factory', component: Factory, label: 'Fábrica', search: 'producao propria industria fabrica' },
            { name: 'Lightbulb', component: Lightbulb, label: 'Ideia', search: 'ideia criatividade sugestao' },
        ]
    },
    {
        group: 'Loja e catálogo',
        icons: [
            { name: 'ShoppingBag', component: ShoppingBag, label: 'Sacola', search: 'compra loja sacola pedido' },
            { name: 'ShoppingCart', component: ShoppingCart, label: 'Carrinho', search: 'compra carrinho pedido' },
            { name: 'Store', component: Store, label: 'Loja', search: 'loja empresa vitrine' },
            { name: 'Gift', component: Gift, label: 'Presente', search: 'brinde presente kit' },
            { name: 'Box', component: Box, label: 'Cubo', search: 'produto item caixa' },
            { name: 'Boxes', component: Boxes, label: 'Estoque', search: 'variedade estoque quantidade' },
            { name: 'Tag', component: Tag, label: 'Etiqueta', search: 'preco etiqueta categoria' },
            { name: 'Tags', component: Tags, label: 'Etiquetas', search: 'variedade categorias precos' },
            { name: 'Barcode', component: Barcode, label: 'Código de barras', search: 'codigo produto sku' },
            { name: 'QrCode', component: QrCode, label: 'QR Code', search: 'qr codigo digital' },
            { name: 'Image', component: Image, label: 'Imagem', search: 'foto imagem catalogo' },
            { name: 'Camera', component: Camera, label: 'Câmera', search: 'foto imagem registro' },
        ]
    },
    {
        group: 'Empresa e prazos',
        icons: [
            { name: 'Building2', component: Building2, label: 'Empresa', search: 'empresa corporativo predio pj' },
            { name: 'Briefcase', component: Briefcase, label: 'Maleta', search: 'corporativo negocio empresa' },
            { name: 'Globe', component: Globe, label: 'Globo', search: 'brasil todo pais nacional mundo' },
            { name: 'Rocket', component: Rocket, label: 'Foguete', search: 'rapido agilidade lancamento' },
            { name: 'Target', component: Target, label: 'Alvo', search: 'objetivo foco resultado' },
            { name: 'Zap', component: Zap, label: 'Raio', search: 'rapido agil expresso energia' },
            { name: 'Leaf', component: Leaf, label: 'Folha', search: 'sustentavel ecologico verde' },
            { name: 'Recycle', component: Recycle, label: 'Reciclagem', search: 'sustentavel reciclado ecologico' },
            { name: 'Calendar', component: Calendar, label: 'Calendário', search: 'prazo data agenda' },
            { name: 'CalendarCheck', component: CalendarCheck, label: 'Prazo cumprido', search: 'prazo entrega data confirmada' },
            { name: 'Timer', component: Timer, label: 'Cronômetro', search: 'prazo rapido tempo minutos' },
            { name: 'RefreshCw', component: RefreshCw, label: 'Atualizar', search: 'reposicao recorrente atualizacao' },
            { name: 'Repeat', component: Repeat, label: 'Recompra', search: 'recorrente recompra repetir' },
            { name: 'Lock', component: Lock, label: 'Cadeado', search: 'seguranca sigilo protecao' },
            { name: 'TrendingUp', component: TrendingUp, label: 'Crescimento', search: 'resultado crescimento vendas' },
            { name: 'Send', component: Send, label: 'Enviar', search: 'envio enviar mensagem' },
        ]
    },
];

const BY_NAME = CATALOG.reduce((map, group) => {
    group.icons.forEach(icon => { map[icon.name] = icon; });
    return map;
}, {});

const normalize = text => (text ?? '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const ICON_CATALOG = CATALOG;

export const ICON_NAMES = Object.keys(BY_NAME);

export const getIcon = name => BY_NAME[name] ?? null;

export const getIconComponent = name => BY_NAME[name]?.component ?? Sparkles;

export const getIconLabel = name => BY_NAME[name]?.label ?? name ?? '';

export const searchIconGroups = term => {
    const query = normalize(term).trim();

    if(query === '') return CATALOG;

    return CATALOG
        .map(group => ({
            group: group.group,
            icons: group.icons.filter(icon =>
                normalize(icon.label).includes(query) ||
                normalize(icon.name).includes(query) ||
                normalize(icon.search).includes(query)
            )
        }))
        .filter(group => group.icons.length > 0);
};
